import { IPaths } from 'Shared/Core/ApiPath/IPaths';

export const OrdersApiPaths: IPaths = {
  Payment: {
    GetPaymentByOrderId: 'Payment/GetPaymentByOrderId',
  },
  Order: {
    CancelOrder: 'Order/Cancel',
    PayOrder: 'Order/WepodPay',
    RedirectToPaymentResultInConfrimWepod: 'Payment/RedirectToPaymentResultInConfrimWepod',
    GetCartItemsTotalCountByCurrentUser: 'Order/GetCartItemsTotalCountByCurrentUserWepod',
    GetAllCartItemsByCurrentUserPaged: 'Order/GetAllCartItemsByCurrentUserPagedWepod',
    GetAllOrderHistoriesByCurrentUserPagedFilter: 'Order/GetAllOrderHistoriesByCurrentUserPagedFilterWepod',
    GetOrderById: 'Order/GetOrderById',
    GenerateHomePageUrl: 'Order/GenerateHomePageUrl',
    getPodUserInfo: 'Order/GetPodUserInfo',
    GenerateIcpUrl: 'Order/GenerateIcpUrl',
  },
};
